import type { FaireProductEntity } from "../../entity_types/product";

export const p_7vud7n8te9: FaireProductEntity = {
  token: "p_7vud7n8te9",
  type: "product",
  name: "CWMM10454_BASEBALL GAME DAY CHARM ELASTIC BRACELET SET",
  brandToken: "b_gd86yguu29",
  brandName: "NINEXIS",
  imageUrl:
    "https://cdn.faire.com/fastly/ed01ec26cc15d0d193e31381e492c474146342e079c5330dfae45d43c57067dc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4efb045d303a66a2974e28ec808148be303677e0fd03de4ac4ed0f3f5d3bc4cb.jpeg",
    "https://cdn.faire.com/fastly/51d97e2c8ab8b22048e2832f285c97d3788add6fd58f5098eda374c10b529ec4.jpeg",
    "https://cdn.faire.com/fastly/c2a5b80331a287f177afeb273ca1377abcf0da267bc26aeda1a877f9631dc8e4.jpeg",
  ],
  priceDollars: 3.46,
  description:
    'BASEBALL GAME DAY CHARM ELASTIC BRACELET SET\n100% POLYMER CLAY\nSIZE  ONE SIZE \nDIAMETER: 2.36"(6 CM), PERIMETER: 7.09"(18 CM)\nMADE IN CHINA \n\nBOHEMIAN BEADED BRACELET, STRETCH BEAD BRACELET, BOHEMIAN JEWELRY,HEART BEAD BRACELET, LOVE CHARM BRACELET, ADJUSTABLE BEADED BRACELET,4-PACK BRACELET SET, ELASTIC BRACELET, NATURAL STONE BRACELET , ALLOY BRACELET,STACKABLE BRACELETS FOR WOMEN, BOHO CHIC GIFT SET, FESTIVAL JEWELRY,FRIENDSHIP GIFT SET, SUMMER BOHO STRETCH BRACELETS, MINIMALISTIC HEART BRACELET SET,BRACELET FOR WOMEN, WOMEN\'S BRACELET, WRISTBAND,BEADED BRACELET, STRETCH BRACELET, CRYSTAL BRACELET, CHARM BRACELET,GEMSTONE BRACELET, PEARL BRACELET, GOLD PLATED BRACELET, LEATHER BRACELET,MINIMALIST BRACELET, VINTAGE BRACELET, YOGA BRACELET,STACKING BRACELETS, FRIENDSHIP BRACELET, GIFT FOR HER, EVERYDAY JEWELRY',
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:51.082Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
